import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BranchCategoryModel } from 'common/models/page-models/branch-category/branch-category-data.model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { BranchCategoryFormWidgetService } from 'common/widget/branch-category/branch-category-form-widget.service';

@Injectable({
    providedIn: 'root'
})
export class BranchCategoryFormResolver extends FormResolverService<BranchCategoryModel> {
    constructor(
        protected fs: BranchCategoryFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
